var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff385c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16.7 13.3q-0.1-0.2-0.3-0.2-0.2-0.1-0.4-0.1-0.2 0-0.4 0.1-0.2 0-0.3 0.2l-1.6 1.6c-0.7-0.2-2.1-0.7-3-1.6-0.9-0.9-1.4-2.3-1.6-3l1.6-1.6q0.2-0.1 0.2-0.3 0.1-0.2 0.1-0.4 0-0.2-0.1-0.4 0-0.2-0.2-0.3l-4-4q-0.1-0.2-0.3-0.2-0.2-0.1-0.4-0.1-0.2 0-0.4 0.1-0.2 0-0.3 0.2l-2.7 2.7c-0.4 0.4-0.6 0.9-0.6 1.4 0 1.5 0.4 6.4 4.3 10.3 3.9 3.9 8.8 4.3 10.3 4.3 0.5 0 1-0.2 1.4-0.6l2.7-2.7q0.2-0.1 0.2-0.3 0.1-0.2 0.1-0.4 0-0.2-0.1-0.4 0-0.2-0.2-0.3zm-0.1 6.7c-1.3 0-5.5-0.4-8.9-3.7-3.4-3.4-3.7-7.7-3.7-8.9l2-2 2.6 2.6-1.3 1.3q-0.2 0.2-0.3 0.4 0 0.3 0 0.5c0 0.1 0.6 2.8 2.3 4.5 1.7 1.7 4.4 2.2 4.5 2.3q0.2 0 0.5 0 0.2-0.1 0.4-0.3l1.3-1.3 2.6 2.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16.8 5.8l-4.5 4.5 1.4 1.4 4.5-4.5 2.8 2.8v-7h-7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.201dd805b5fa5c136e853fe97ce06898.svg";
export { ForwardRef as ReactComponent };